import React from 'react';
import { Box, Button, Stack, Typography } from '@mui/material';

const BuySellDafUpload = ({
  show = true,
  title = 'DAF Upload',
  description,
  dafFile,
  existingFileName,
  error,
  onFileChange,
  onClearFile,
  missingWarning,
  missingWarningText,
}) => {
  if (!show) return null;

  return (
    <Box
      sx={{
        border: '1px dashed',
        borderColor: 'divider',
        borderRadius: 2,
        p: 2,
        bgcolor: 'action.hover',
      }}
    >
      <Stack spacing={1.25}>
        <Box>
          <Typography variant="subtitle2">{title}</Typography>
          {description && (
            <Typography variant="body2" sx={{ color: 'text.secondary' }}>
              {description}
            </Typography>
          )}
        </Box>
        <Stack direction="row" spacing={1} sx={{ alignItems: 'center', flexWrap: 'wrap' }}>
          <Button component="label" variant="contained" size="small">
            Upload DAF.pdf
            <input hidden type="file" accept="application/pdf" onChange={onFileChange} />
          </Button>
          {dafFile && (
            <Button size="small" onClick={onClearFile}>
              Clear selection
            </Button>
          )}
        </Stack>
        {existingFileName && (
          <Typography variant="caption" sx={{ color: 'text.secondary' }}>
            Current file: {existingFileName}
          </Typography>
        )}
        <Typography variant="body2" sx={{ color: error ? 'error.main' : 'text.secondary' }}>
          {error || (dafFile?.name || 'No file selected yet.')}
        </Typography>
        {missingWarning && (
          <Typography variant="caption" sx={{ color: 'warning.main' }}>
            {missingWarningText}
          </Typography>
        )}
      </Stack>
    </Box>
  );
};

export default BuySellDafUpload;
